module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!--  css in staticUCs.css  -->\r\n<div class="table_BriqueSituationsARegulariser cw-aucunSit"></div>';
}
return __p;
};
